import React, { FC } from 'react'
import styles from 'styles/components/button.module.scss'

type Props = {
  disabled?: boolean
  direction: 'prev' | 'next'
  onClick: () => void
}

const ArrowButton: FC<Props> = React.memo((props) => {
  const { disabled, direction, onClick } = props

  const className = (() => {
    switch (true) {
      case direction === 'prev' && disabled:
        return styles.button__arrow_prev_disabled
      case direction === 'prev' && !disabled:
        return styles.button__arrow_prev
      case direction === 'next' && disabled:
        return styles.button__arrow_next_disabled
      case direction === 'next' && !disabled:
        return styles.button__arrow_next
      default:
        return styles.button__arrow_prev
    }
  })()

  return (
    <button className={className} onClick={onClick}>
      <span />
    </button>
  )
})

export default ArrowButton
